import axios from "axios";
import Swal from "sweetalert2";

// Constants
const API_BASE_URL = "https://campus.acetians.in/api/v2/admission/save2";

export const showErrorAlert = (message, focusElementId) => {
  Swal.fire({
    icon: "error",
    title: "Validation Error",
    text: message,
    confirmButtonColor: "#3085d6",
  }).then(() => {
    if (focusElementId) {
      const element = document.getElementById(focusElementId);
      if (element) {
        element.focus();
      }
    }
  });
};

export const showSuccessAlert = (message) => {
  Swal.fire({
    icon: "success",
    title: "Success",
    text: message,
    confirmButtonColor: "#3085d6",
  });
};

export const showLoading = () => {
  Swal.fire({
    title: "Saving Data...",
    allowEscapeKey: false,
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });
};

export const closeLoading = () => {
  Swal.close();
};

export const FormService = {
  async submitForm(formData, course) {
    console.log(formData);
    console.log(formData.high_school_year);
    try {
      console.log(formData);
      const formDataToSend = new FormData();

      // Basic Information

      formDataToSend.append("course", course);
      formDataToSend.append("urn", formData.urn ?? "");
      formDataToSend.append("applicant_name", formData.applicant_name ?? "");
      formDataToSend.append("mother_name", formData.mother_name ?? "");
      formDataToSend.append("father_name", formData.father_name ?? "");
      formDataToSend.append("dob", formData.dob);
      formDataToSend.append("gender", formData.gender ?? "");
      formDataToSend.append("category", formData.category ?? "");
      formDataToSend.append("sub_category", formData.sub_category || "");
      formDataToSend.append("email", formData.email ?? "");
      formDataToSend.append("whatsapp_number", formData.whatsapp_number ?? "");
      formDataToSend.append("aadhar_no", formData.aadhar_no ?? "");





        formDataToSend.append("caste_certificate_number", formData.caste_certificate_number || "");
      formDataToSend.append("father_occupation", formData.father_occupation ?? "");
      formDataToSend.append("mother_occupation", formData.mother_occupation ?? "");
      formDataToSend.append("marital_status", formData.marital_status ?? "");

       formDataToSend.append(
        "gap",
        formData.gap || ""
      );

      // Address Details
      formDataToSend.append(
        "permanent_address_village_mohalla",
        formData.permanent_address_village_mohalla ?? ""
      );
      formDataToSend.append(
        "permanent_address_post",
        formData.permanent_address_post ?? ""
      );
      formDataToSend.append(
        "permanent_address_tehsil",
        formData.permanent_address_tehsil ?? ""
      );
      formDataToSend.append(
        "permanent_address_district",
        formData.permanent_address_district || ""
      );
     

       formDataToSend.append(
        "permanent_address_pincode",
        formData.permanent_address_pincode || ""
      );

   
      // Handle arrays for horizontal_reservation and weightage
      if (Array.isArray(formData.horizontal_reservation)) {
        formData.horizontal_reservation.forEach((item) => {
          formDataToSend.append("horizontal_reservation[]", item);
        });
      }

      if (Array.isArray(formData.weightage)) {
        formData.weightage.forEach((item) => {
          formDataToSend.append("weightage[]", item);
        });
      }

     


      if (Array.isArray(formData.attachments)) {
        formData.attachments.forEach((item) => {
          formDataToSend.append("attachments[]", item);
        });
      }

    
    
      // Education Details
      // High School
      formDataToSend.append(
        "high_school_year",
        formData.high_school_year || ""
      );
      formDataToSend.append(
        "high_school_board",
        formData.high_school_board || ""
      );
      formDataToSend.append(
        "high_school_name",
        formData.high_school_name || ""
      );
      formDataToSend.append(
        "high_school_roll",
        formData.high_school_roll ?? ""
      );
      formDataToSend.append(
        "high_school_maxmarks",
        formData.high_school_maxmarks ?? ""
      );
      formDataToSend.append(
        "high_school_obtmarks",
        formData.high_school_obtmarks ?? ""
      );
      formDataToSend.append(
        "high_school_percentage",
        formData.high_school_percentage || ""
      );
     

      // Intermediate
      formDataToSend.append(
        "intermediate_year",
        formData.intermediate_year ?? ""
      );
      formDataToSend.append(
        "intermediate_board",
        formData.intermediate_board ?? ""
      );
      formDataToSend.append(
        "intermediate_name",
        formData.intermediate_name ?? ""
      );
      formDataToSend.append(
        "intermediate_roll",
        formData.intermediate_roll ?? ""
      );
      formDataToSend.append(
        "intermediate_maxmarks",
        formData.intermediate_maxmarks ?? ""
      );
      formDataToSend.append(
        "intermediate_obtmarks",
        formData.intermediate_obtmarks ?? ""
      );
      formDataToSend.append(
        "intermediate_percentage",
        formData.intermediate_percentage || ""
      );
      formDataToSend.append(
        "intermediate.subject",
        formData.intermediate_subject || ""
      );

      // UG
      formDataToSend.append(
        "ug_year",
        formData.ug_year ?? ""
      );
      formDataToSend.append(
        "ug_board",
        formData.ug_board ?? ""
      );
      formDataToSend.append(
        "ug_name",
        formData.ug_name ?? ""
      );
      formDataToSend.append(
        "ug_roll",
        formData.ug_roll ?? ""
      );
      formDataToSend.append(
        "ug_maxmarks",
        formData.ug_maxmarks ?? ""
      );
      formDataToSend.append(
        "ug_obtmarks",
        formData.ug_obtmarks ?? ""
      );
      formDataToSend.append(
        " ug_percentage",
        formData.ug_percentage || ""
      );


       // Other
      formDataToSend.append(
        "other_year",
        formData.other_year ?? ""
      );
      formDataToSend.append(
        "other_board",
        formData.other_board ?? ""
      );
      formDataToSend.append(
        "other_name",
        formData.other_name ?? ""
      );
      formDataToSend.append(
        "other_roll",
        formData.other_roll ?? ""
      );
      formDataToSend.append(
        "other_maxmarks",
        formData.other_maxmarks ?? ""
      );
      formDataToSend.append(
        "other_obtmarks",
        formData.other_obtmarks ?? ""
      );
      formDataToSend.append(
        " other_percentage",
        formData.other_percentage || ""
      );
      
      // Compulsory Subjects
      // if (Array.isArray(formData.compulsory_subjects)) {
      //   formData.compulsory_subjects.forEach((subject) => {
      //     formDataToSend.append("compulsory_subjects[]", subject);
      //   });
      // }

      // Declarations
      // formDataToSend.append("is_ufmeans", formData.is_ufmeans ?? "");
      // formDataToSend.append("has_scholarship", formData.has_scholarship ?? "");
      // formDataToSend.append("is_casefiled", formData.is_casefiled ?? "");
      // formDataToSend.append("is_rustigated", formData.is_rustigated ?? "");
      // formDataToSend.append("is_civilservant", formData.is_civilservant ?? "");
      formDataToSend.append(
        "agreed_to_declaration",
        formData.agreed_to_declaration ? "1" : "0"
      );

      // Handle image and signature
      // if (formData.image instanceof File) {
      //   formDataToSend.append("image", formData.image);
      // }

      if (formData. mark_10th instanceof File) {
        formDataToSend.append(" mark_10th", formData. mark_10th);
      }
      if (formData.mark_12 instanceof File) {
        formDataToSend.append("mark_12", formData.mark_12);
      }
      if (formData.aadhar instanceof File) {
        formDataToSend.append("aadhar", formData.aadhar);
      }
      if (formData.mark_ug instanceof File) {
        formDataToSend.append("mark_ug", formData.mark_ug);
      }
      if (formData.mark_other instanceof File) {
        formDataToSend.append("mark_other", formData.mark_other);
      }
      if (formData.dc_caste instanceof File) {
        formDataToSend.append("dc_caste", formData.dc_caste);
      }
      if (formData.dc_domicile instanceof File) {
        formDataToSend.append("dc_domicile", formData.dc_domicile);
      }
      if (formData.dc_tc instanceof File) {
        formDataToSend.append("dc_tc", formData.dc_tc);
      }
      if (formData.dc_income instanceof File) {
        formDataToSend.append("dc_income", formData.dc_income);
      }
        if (formData.dc_anti_ragging_affidavit instanceof File) {
        formDataToSend.append("dc_anti_ragging_affidavit", formData.dc_anti_ragging_affidavit);
      }
       







       if (formData.image instanceof File) {
        formDataToSend.append("image", formData.image);
      }

      if (formData.signature instanceof File) {
        formDataToSend.append("signature", formData.signature);
      }

       const token = localStorage.getItem("auth_token");

      const response = await axios.post(API_BASE_URL, formDataToSend,  {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      
      });

      console.log(response.data["admission_code"]);

      return response.data;
    } catch (error) {
      console.log(error);
      console.error("Submission error:", error);
      let errorMessage = "An error occurred while submitting the form";

      if (error.response) {
        errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          error.response.statusText;
      } else if (error.request) {
        errorMessage = "No response received from server";
      }

      throw new Error(errorMessage);
    }
  },

  async validateStep(step, formData) {
    return new Promise((resolve) => {
      setTimeout(() => {
        const requiredFields = {
          1: [
            "urn",
            "applicant_name",
            "mother_name",
            "father_name",
            "dob",
            "gender",
            "religion",
            "category",
            "email",
            "applicant_mobile",
            "aadhar_no",
            "c_address",
          ],
          2: [
            "nationality",
            "is_minority",
            "is_otherenrollment",
            "is_upresidence",
          ],
          3: [
            "annual_income",
            "income_certificate_no",
            "bank_name",
            "branch",
            "account_no",
            "ifsc_code",
          ],
          4: [
            "high_school_year",
            "high_school_board",
            "high_school_name",
            "high_school_roll",
            "high_school_maxmarks",
            "high_school_obtmarks",
            "intermediate_year",
            "intermediate_board",
            "intermediate_name",
            "intermediate_roll",
            "intermediate_maxmarks",
            "intermediate_obtmarks",
          ],
          5: ["image", "signature"],
          6: [
            "is_ufmeans",
            "has_scholarship",
            "is_casefiled",
            "is_rustigated",
            "is_civilservant",
            "agreed_to_declaration",
          ],
        };

        const errors = [];
        const stepFields = requiredFields[step] || [];

        stepFields.forEach((field) => {
          if (field.includes(".")) {
            const [parent, child] = field.split(".");
            if (!formData[parent]?.[child]) {
              errors.push(field);
            }
          } else if (!formData[field]) {
            errors.push(field);
          }
        });

        resolve({
          valid: errors.length === 0,
          errors: errors.length > 0 ? errors : undefined,
        });
      }, 500);
    });
  },
};
